import type { Router } from '../types';

const defaults: Readonly<Router> = {
  pathname: '',
  query: {},
};

export const routerBuilder = (router: Partial<Router> = {}): Readonly<Router> => ({
  ...defaults,
  ...router,
});
